import Page from '../common/page'
import bus from '~/bus'

const state = Object.assign({}, Page.state)
state.endpoint = 'files/account/:id'
state.sortOptions = {
  'Date': ['-created_datetime'],
  'Name': ['name']
}
state.account = {}

export default {
  namespaced: true,
  state,
  getters: Page.getters,
  mutations: {...Page.mutations,
    account (state, account) {
      state.account = account
    }
  },
  actions: {...Page.actions,
    loadElements (context, ...params) {
      return Page.actions.loadElements(context, ...params).then(response => {
        context.commit('account', response.body.account_owner)
        bus.$emit('sharer/loadedAccount', response.body.account_owner || {})
        return response
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/sharers/sharer.js